import { IconNames } from '@blueprintjs/icons';
import { ActionButtonText } from '@strata/react-buttons';
import { NumberInputFormik, TextInputFormik } from '@strata/react-inputs';
import { DetailLabel } from '@strata/react-label-value-pairs';
import { RadioButtonGroupFormik } from '@strata/react-radio-button-group';
import { Icon } from '@strata/react-status-icons';
import { FieldArray } from 'formik';

import { ListPageHeader } from 'components/ListPageHeader';

const YES_NO_OPTIONS = ['Yes', 'No'];

export const OrtfConfigurationFields = () => (
    <>
        <ListPageHeader pageTitle="ORTF Configuration" />
        <DetailLabel label="Send ORTF Outbound Files?" />
        <RadioButtonGroupFormik name="ortf_outbound_enabled" options={YES_NO_OPTIONS} />
        <TextInputFormik label="ORTF Receiving First Name" id="receiving_pharmacist_first_name" />
        <TextInputFormik label="ORTF Receiving Last Name" id="receiving_pharmacist_last_name" />
        <FieldArray name="receiving_pharmacist_emails">
            {(arrayHelpers) => {
                const emails = arrayHelpers.form.values.receiving_pharmacist_emails;
                return (
                    <div className="margin__bottom--large">
                        {emails.map((_, index) => (
                            <div
                                // eslint-disable-next-line react/no-array-index-key
                                key={index}
                                className="flex__gap--small"
                            >
                                <div style={{ flex: 1 }}>
                                    <TextInputFormik
                                        id={`${arrayHelpers.name}.${index}`}
                                        label={
                                            index === 0
                                                ? 'ORTF Receiving Pharmacist Email'
                                                : undefined
                                        }
                                    />
                                </div>
                                {emails.length > 1 && (
                                    <Icon
                                        icon={IconNames.TRASH}
                                        intent={Icon.Intent.SECONDARY}
                                        title="Delete"
                                        className={
                                            index === 0
                                                ? 'margin__top--large'
                                                : 'margin__top--small'
                                        }
                                        onClick={() => arrayHelpers.remove(index)}
                                    />
                                )}
                            </div>
                        ))}
                        <ActionButtonText
                            label="Add Email"
                            leftIcon={IconNames.ADD}
                            onClick={() => arrayHelpers.push('')}
                        />
                    </div>
                );
            }}
        </FieldArray>
        <DetailLabel label="Segment by Payer" />
        <RadioButtonGroupFormik name="segment_by_payer" options={YES_NO_OPTIONS} />
        <DetailLabel label="Segment by BIN/PCN" />
        <RadioButtonGroupFormik name="segment_by_bin_pcn" options={YES_NO_OPTIONS} />
        <NumberInputFormik
            label="Script Threshold"
            id="script_count_threshold"
            required
            step="1"
            maxDecimalPlaces={0}
        />
    </>
);
